import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Pagination } from '../../../core/models/pagination.model';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-lift-filter',
  templateUrl: './lift-filter.component.html',
  styleUrls: ['./lift-filter.component.css']
})
export class LiftFilterComponent implements OnInit {

  @Input()
  pagination: Pagination;
  searchBox = new FormControl();
  activeSwitch = 'active';

  @Output()
  onSearch = new EventEmitter<string>();

  @Output()
  onActiveFilter = new EventEmitter<string>();

  constructor() {
    this.searchBox
      .valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe(term => {
        this.onSearch.emit(term);
      });
  }

  ngOnInit() {
  }

  get allItems() {
    return this.pagination.totalItems;
  }

  activeFilterChange(activeFilter: string) {
    this.activeSwitch = activeFilter;
    this.onActiveFilter.emit(activeFilter);
  }

}
